import { useSegment } from "src/hooks/useSegment";
import { useCallback, useMemo, useState } from "react";
import { DropdownOutlined } from "src/atoms/DropDown";
import { FilterCountBadge } from "src/atoms/FilterCountBadge";
import { SizesList } from "./SizesList";
import type { ListingFacet } from "src/types/adapters/listing.type";

type SizesProps = {
  facet: ListingFacet;
  placeholder: string;
};

function Sizes({ facet, placeholder }: SizesProps) {
  const [isOpen, setOpen] = useState(false);
  const { segmentProductListFilterOpened } = useSegment();

  const activeCount = useMemo(() => {
    if (facet.type === "range") return 0;

    return facet.data.filter((option) => option.selected).length;
  }, [facet]);

  const toggleOpen = useCallback(() => {
    setOpen((prev) => {
      const next = !prev;
      if (next) {
        void segmentProductListFilterOpened(facet.key);
      }
      return next;
    });
  }, [facet.key, segmentProductListFilterOpened]);

  const closeDropdown = useCallback(() => setOpen(false), []);

  return (
    <DropdownOutlined
      opened={isOpen}
      hasActiveFilters={activeCount > 0}
      width={477}
      onClose={closeDropdown}
    >
      <DropdownOutlined.Button onClick={toggleOpen}>
        <span>
          {placeholder}
          <FilterCountBadge count={activeCount} />
        </span>
      </DropdownOutlined.Button>
      {isOpen ? (
        <DropdownOutlined.Items>
          <SizesList facet={facet} />
        </DropdownOutlined.Items>
      ) : null}
    </DropdownOutlined>
  );
}

export { Sizes };
